export default __webpack_public_path__ + "static/slovenia-control-57cd8401a2d33f82816026f48c43635d.png";